import React, { useState, useEffect, useRef } from "react";
import { heroBanners } from "../data/products";
import { Link } from "react-router-dom";
import "../assets/css/hero.css";

export default function Hero() {
  const [index, setIndex] = useState(0);
  const slideRef = useRef();

  // Auto slide
  useEffect(() => {
    const timer = setInterval(() => {
      next();
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const next = () => {
    setIndex((prev) => (prev + 1) % heroBanners.length);
  };

  const prev = () => {
    setIndex((prev) => 
      prev === 0 ? heroBanners.length - 1 : prev - 1
    );
  };

  return (
    <section className="hero-slider">
      <div
        className="hero-track"
        style={{
          transform: `translateX(-${index * 100}%)`,
        }}
        ref={slideRef}
      >
        {heroBanners.map((banner, i) => (
          <div
            key={i}
            className="hero-slide"
            style={{ backgroundImage: `url(${banner.image})` }}
          >
            <div className="overlay"></div>

            <div className="container">
              <div className="hero-content">
                <h1>{banner.title}</h1>
                <p>{banner.subtitle}</p>

                <Link
                  to={`/product/${banner.productSlug}`}
                  className="btn btn-primary"
                >
                  Explore Product
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Arrows */}
      <button className="carousel-arrow left" onClick={prev}>
        <i className="fas fa-chevron-left"></i>
      </button>
      <button className="carousel-arrow right" onClick={next}>
        <i className="fas fa-chevron-right"></i>
      </button>

      {/* Dots */}
      <div className="carousel-dots">
        {heroBanners.map((_, i) => (
          <span
            key={i}
            className={`dot ${i === index ? "active" : ""}`}
            onClick={() => setIndex(i)}
          ></span>
        ))}
      </div>
    </section>
  );
}
